import classNames from "classnames/bind";
import RichText from "common/blocks/RichText";
import ExtrasCard, {
    ExtrasCardProps,
} from "features/vehicleDetails/components/ExtrasRow/ExtrasCard";
import { ResolvedRichText } from "resolvers/data/richTextResolver";

import styles from "./ExtrasRow.module.scss";

const cx = classNames.bind(styles);

export type ExtrasRowProps = {
    components: {
        extrasCards: ExtrasCardProps[];
        extrasContainerHeader: string;
        extrasContainerFooterText: ResolvedRichText;
    };
};

export const ExtrasRow = ({ components }: ExtrasRowProps) => {
    return (
        <div className={cx("extrasRow")}>
            <div className={cx("extrasHeading")}>{components.extrasContainerHeader}</div>
            <div className={cx("extrasCardsContainer")}>
                {components?.extrasCards?.map((card, index) => (
                    <ExtrasCard
                        key={`extra-${index}`}
                        headingText={card.headingText}
                        subHeadingText={card.subHeadingText}
                        bodyText={card.bodyText}
                        cardLinkText={card.cardLinkText}
                        urlLink={card.urlLink}
                        image={card.image}
                    />
                ))}
            </div>
            {!!components.extrasContainerFooterText && (
                <div className={cx("bottomContainer")}>
                    <div className={cx("bottomContent")}>
                        <RichText {...components.extrasContainerFooterText} />
                    </div>
                </div>
            )}
        </div>
    );
};
